import {
  Avatar,
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ListItemText,
  MenuItem,
  MenuList,
  TextField,
  Theme,
  Typography,
  WithStyles,
  withStyles,
  Divider,
} from "@material-ui/core";
import * as React from "react";
import ErrorIon from "../assets/images/error.png";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_INPUT: "DIALOG_INPUT",
  DIALOG_ACTION: "DIALOG_ACTION",
  DIALOG_ERROR: "DIALOG_ERROR",
};
const styles = (theme: Theme) => createStyles({});
interface Props extends WithStyles<typeof styles> {
  type: any;
  title: any;
  message?: any;
  messages?: any;
  actions?: any;
  leftButtonName?: any;
  rightButtonName?: any;
  leftButtonDisable?: any;
  rightButtonDisable?: any;
  open: any;
  textInputLabel?: any;
  textInputError?: any;
  handleTextInputChanged?: any;
  handleClose?: any;
  onCancel?: any;
  onOk?: any;
  onKeyPressed?: any;
}
class GenericDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    hasError: false,
  };
  renderMessage = (message: any) => {
    return (
      <DialogContentText id="alert-dialog-slide-description">
        {message}
      </DialogContentText>
    );
  };

  renderMessages = (messages: [any]) => {
    return messages.map((message, index) => (
      <>
        <Typography key={index.toString()} gutterBottom>
          {message}
        </Typography>
        {message.toLowerCase().includes("Password".toLowerCase()) && (
          <Typography
            key={`more-${index.toString()}`}
            variant={"caption"}
            style={{ fontStyle: "italic" }}
          >
            {
              "Email this password to the user and remind them to reset it immediately."
            }
          </Typography>
        )}
      </>
    ));
  };

  renderErrorMessage = (message: any) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Avatar>
          <img
            alt={"Error"}
            style={{ width: 30, height: 30, color: "white" }}
            src={ErrorIon}
          />
        </Avatar>
        <Typography
          style={{ fontSize: 18, color: "red", marginLeft: 10 }}
          gutterBottom
        >
          {message}
        </Typography>
      </div>
    );
  };

  render() {
    const {
      type,
      title,
      message,
      messages,
      actions,
      leftButtonName,
      rightButtonName,
      leftButtonDisable,
      rightButtonDisable,
      open,
      textInputLabel,
      textInputError,
      handleTextInputChanged,
      handleClose,
      onCancel,
      onOk,
      onKeyPressed,
    } = this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
          <Divider />
          <DialogContent>
            {type === types.DIALOG_INFO && (
              <div>
                {message && this.renderMessage(message)}
                {messages &&
                  messages.length > 0 &&
                  this.renderMessages(messages)}
              </div>
            )}
            {type === types.DIALOG_ERROR && (
              <div>{message && this.renderErrorMessage(message)}</div>
            )}
            {type === types.DIALOG_INPUT && (
              <div>
                {message && this.renderMessage(message)}
                {messages && this.renderMessages(messages)}
                <TextField
                  margin="dense"
                  autoComplete="nope"
                  error={textInputError}
                  label={textInputLabel}
                  fullWidth
                  onChange={handleTextInputChanged}
                  onKeyPress={onKeyPressed}
                />
              </div>
            )}
            {type === types.DIALOG_ACTION && (
              <MenuList>
                {actions.map((action: any, index: Number) => (
                  <MenuItem
                    key={index.toString()}
                    onClick={action.handleAction}
                  >
                    {action.icon && action.renderIcon}
                    <ListItemText
                      primary={action.title}
                      secondary={action.subtitle}
                    />
                    {action.isDelete && action.renderDeleteIcon}
                  </MenuItem>
                ))}
              </MenuList>
            )}
          </DialogContent>
          <DialogActions>
            {leftButtonName && (
              <Button onClick={onCancel} disabled={leftButtonDisable}>
                {leftButtonName}
              </Button>
            )}
            {rightButtonName && (
              <Button onClick={onOk} disabled={rightButtonDisable}>
                {rightButtonName}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(GenericDialog);
